'use strict';

var accordion = {};

exports.__exports = accordion;
//# sourceMappingURL=accordion2.cjs.map
